import { API } from 'aws-amplify'

export function createOrganization(data) {
  const query = `mutation create (
            $name: String!, 
            $identifier: IdetifierInput, 
            $address: AddressInput, 
            $contactPoint: ContactPointInput
          ) {
            createOrganization(
              name: $name
              identifier: $identifier
              address: $address
              contactPoint: $contactPoint
            ) {
              name
              identifier {
                id
                scheme
              }
            }
          }
          `

  return API.graphql({
    query,
    variables: {
      name: data.name,
      identifier: {
        id: data.id,
        scheme: data.scheme,
        legalName: data.name,
      },
      address: {
        streetAddress: data.address,
        locality: data.city,
        region: data.region,
        postalCode: data.postalCode,
        countryName: data.country,
      },
      contactPoint: {
        name: data.name,
        email: data.email,
        telephone: data.phone,
      },
    },
  })
}

export function updateOrganization(id, data) {
  const query = `mutation updateOrganization (
      $organizationId: String!
      $name: String!,
      $identifier: IdetifierInput,
      $address: AddressInput!,
      $contactPoint: ContactPointInput
    ) {
      updateOrganization(
        organizationId: $organizationId
        name: $name
        identifier: $identifier
        address: $address
        contactPoint: $contactPoint
      ) {
        name
        address {
          streetAddress
          locality
          region
          postalCode
          countryName
        }
        contactPoint {
          name
          email
          telephone
        }
      }
    }`

  return API.graphql({
    query,
    variables: {
      organizationId: id,
      name: data.name,
      identifier: data.identifier,
      address: {
        countryName: data.address.countryName,
        region: data.address.region,
        locality: data.address.locality,
        postalCode: data.address.postalCode,
        streetAddress: data.address.streetAddress,
      },
      contactPoint: data.contactPoint,
    },
  })
}

export function inviteToOrganization({ organizationId, email, role }) {
  const query = `mutation inviteToOrganization (
      $organizationId: String!
      $email: String!,
      $role: String,
    ) {
      inviteToOrganization(
        organizationId: $organizationId
        email: $email
        role: $role
      ) {
        mpID
        organizationId
        email
        status
      }
    }`

  return API.graphql({
    query,
    variables: {
      organizationId,
      email,
      role,
    },
  })
}

export function getOrganization(id) {
  const query = `query getOrganization ($id: String!) {
        getOrganization(id: $id) {
        name
        logo
        members
        identifier {
          id
          scheme
          legalName
        }
        address {
          streetAddress
          locality
          region
          postalCode
          countryName
        }
        contactPoint {
          name
          email
          telephone
        }
      }
    }
    `

  return API.graphql({
    query,
    variables: { id },
  })
}

export function getOrganizationInvitation(mpID) {
  const query = `query getOrganizationInvitation ($mpID: String!) {
    getOrganizationInvitation(mpID: $mpID) {
      mpID
      organizationId
      email
      status
    }
  }`

  return API.graphql({
    query,
    variables: {
      mpID,
    },
    authMode: 'AWS_IAM',
  });
}

export function getOrganizationMembers(organizationId) {
  const query = `query getOrganizationMembers ($organizationId: String) {
    getOrganizationMembers(organizationId: $organizationId) {
      data {
        mpID
        name
        email
      }
    }
  }`

  return API.graphql({
    query,
    variables: {
      organizationId,
    },
  });
}

export function updateOrganizationLogo(organizationId, logo) {
  const query = `mutation updateOrganization($organizationId: String!, $logo: String) {
      updateOrganization(
        organizationId: $organizationId
        logo: $logo,
      ) {
        name
      }
    }`;

  return API.graphql({
    query,
    variables: {
      organizationId,
      logo,
    },
  })
}
